// extracted by mini-css-extract-plugin
export default {"container":"StatusMessage_container__Nta5S","message":"StatusMessage_message__WQQxJ"};